import React from 'react'
import PropTypes from 'prop-types'

export default class HandoverHoursFilter extends React.Component {
  state = {
    changedTime: null,
  }

  handleChange = (e) => {
    const { setHoursVisible } = this.props
    const num = parseInt(e.target.value)
    this.setState({ changedTime: num })
    setHoursVisible(null)
    setHoursVisible(num)
  }

  render() {
    const { hasRecentHandover, hoursVisible, style } = this.props

    if (hasRecentHandover) {
      return (
        <div style={{ ...style, ...styles.previousText }}>
          Since previous handover
        </div>
      )
    }

    return (
      <select
        className="lmc-handover-select"
        style={{ ...style, ...styles.select }}
        value={hoursVisible || this.state.changedTime}
        onChange={this.handleChange}
      >
        <option value={48}>48 hours</option>
        <option value={24}>24 hours</option>
        <option value={12}>12 hours</option>
        <option value={8}>8 hours</option>
        <option value={4}>4 hours</option>
      </select>
    )
  }
}

const styles = {
  previousText: {
    fontSize: 12,
    opacity: 0.8,
    paddingBottom: 8,
  },
  select: {
    border: 'none',
    background: 'inherit',
    cursor: 'pointer',
    fontWeight: 600,
    padding: '0px 10px 8px 10px',
    textAlign: 'right',
    width: 120,
  },
}

HandoverHoursFilter.propTypes = {
  hasRecentHandover: PropTypes.bool.isRequired,
  hoursVisible: PropTypes.number,
  setHoursVisible: PropTypes.func.isRequired,
  style: PropTypes.object,
}
